import React, { Component } from "react"
import PropTypes from "prop-types"
import omit from "lodash/omit"
import { FieldType } from "./custom-field-settings"

const fieldName = name => `fields[${name}]`

export class CustomField extends Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    field_type: PropTypes.string,
    innerRef: PropTypes.any,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    new: PropTypes.bool,
    required: PropTypes.bool,
    style: PropTypes.object,
    tags: PropTypes.arrayOf(PropTypes.object),
    onClick: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.input = React.createRef()
  }

  componentDidMount() {
    if (this.props.new && this.input.current) {
      this.input.current.focus()
    }
  }

  render() {
    const {
      id,
      name,
      field_type,
      label,
      required,
      tags,
      onChange,
      onClick,
      style,
      innerRef,
      ...props
    } = this.props

    const { color, fontWeight } = style || {}

    return field_type == FieldType.Checkboxes ? (
      <div
        onClick={onClick}
        onKeyPress={e => {
          if (e.key === "Enter") {
            onClick()
          }
        }}
        role="button"
        tabIndex="0"
      >
        <fieldset
          data-group="checkboxes"
          {...omit(props, "new")}
          ref={innerRef}
        >
          {label && <legend style={{ color, fontWeight }}>{label}</legend>}
          {tags &&
            tags.map(tag => (
              <div
                className="formkit-checkboxes"
                data-element="tags-checkboxes"
                data-group="checkbox"
                style={style}
                key={tag.value}
              >
                <input
                  className="formkit-checkbox"
                  id={`tag-${id}-${tag.value}`}
                  type="checkbox"
                  name="tags[]"
                  value={tag.value}
                />
                <label htmlFor={`tag-${id}-${tag.value}`}>
                  {tag.display_label}
                </label>
              </div>
            ))}
        </fieldset>
      </div>
    ) : field_type == FieldType.Dropdown ? (
      <div data-group="dropdown" ref={innerRef} {...omit(props, "new")}>
        <select
          className="formkit-select"
          style={style}
          data-element="tags-select"
          name="tags[]"
          onFocus={onClick}
          required={required}
        >
          <option value="">{label}</option>
          {tags &&
            tags.map(tag => (
              <option key={tag.value} value={tag.value}>
                {tag.display_label}
              </option>
            ))}
        </select>
      </div>
    ) : (
      <input
        className="formkit-input"
        ref={innerRef}
        aria-label={label}
        style={style}
        name={fieldName(name)}
        required={required}
        placeholder={label}
        type="text"
        onClick={onClick}
      />
    )
  }
}
